import { Injectable } from '@angular/core';
import { LcsApiService } from '@lcs/shared/api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { EMPTY, of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { Tile } from 'src/app/pages/tiles/models/tile.model';
import { TileSet } from '../models/tile-set.model';
import {
   GetTilesTileSet,
   GetTilesTileSetVariables,
   GetTilesTileSet_tilesConnection_items,
} from '../queries/generated/GetTilesTileSet';
import { getTilesTileSet } from '../queries/get-tile-tile-set.graphql';
import { loadTileSet, loadTileSetFailure, loadTileSetSuccess } from './tile-set-type-select.actions';
import { selectTileSets } from './tile-set-type-select.selectors';

@Injectable()
export class TileSetTypeSelectEffects {
   loadTileSet$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(loadTileSet),
         withLatestFrom(this.store.pipe(select(selectTileSets))),
         switchMap(([action, tileSets]) => {
            if (tileSets[action.tileId]) return EMPTY;

            return this.apiService
               .query<GetTilesTileSet, GetTilesTileSetVariables>({
                  query: getTilesTileSet,
                  variables: { filters: `tileId = ${action.tileId}` },
               })
               .pipe(
                  map((response) =>
                     loadTileSetSuccess({
                        tileSet: this.mapToTileSet(response.data.tilesConnection.items[0]),
                     })
                  ),
                  catchError((error) => of(loadTileSetFailure(error)))
               );
         })
      );
   });

   constructor(private store: Store, private actions$: Actions, private apiService: LcsApiService) {}

   private mapToTileSet(data: GetTilesTileSet_tilesConnection_items): TileSet {
      return {
         tileId: data.tileId ?? null,
         tileSetId: data.tileSetType?.tileSet.tileSetId ?? null,
         name: data.tileSetType?.tileSet.name ?? '',
         description: data.tileSetType?.tileSet.description ?? '',
         designerDescription: data.tileSetType?.tileSet.designerDescription ?? '',
         tileSetTypes:
            data.tileSetType?.tileSet.tileSetTypeConnection.items.map((tstc) => {
               return {
                  tileSetTypeId: tstc.tileSetTypeId,
                  tile: tstc.tile as Tile,
               };
            }) ?? [],
      };
   }
}
